import styled from 'styled-components';
import { useIsRightPanelExpanded } from '../../../../services/listVehiclesSlice/listVehiclesSlice';
import { useGetRequestsByDayQuery } from '../../../../services/api/list-vehicles';
import { DayBlock } from './DayBlock';

const Wrapper = styled.div<{ isOpen: boolean }>`
  position: fixed;
  right: 96px;
  top: calc(48px + 56px + 72px + 12px);
  max-height: calc(100vh - 96px - 56px - 72px - 12px);
  overflow-y: auto;
  width: 300px;
  z-index: 10;
  background: #fff;
  box-shadow: 0px 4px 4px 0px #00000040;
  padding: 20px 12px;
  flex-grow: 1;
  flex-direction: column;
  gap: 12px;
  opacity: ${props => (props.isOpen ? '1' : '0')};
  visibility: ${props => (props.isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.5s ease-in-out;
  display: flex;

  @media (min-width: 1450px) {
    right: 10%;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Title = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #000;
`;

export const RightPanel = () => {
  const isOpen = useIsRightPanelExpanded();
  const { data } = useGetRequestsByDayQuery();

  return (
    <Wrapper isOpen={isOpen}>
      <Title>THIS WEEKS STORES</Title>
      <ContentWrapper>
        {data?.map((d, i) => (
          <DayBlock key={i} data={d} dayNumber={i} />
        ))}
      </ContentWrapper>
    </Wrapper>
  );
};
